import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ImgLes",
  "use": "icon-ImgLes-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ImgLes\"><path d=\"M443.744 68.256c207.36 0 375.456 168.128 375.456 375.488 0 100.064-39.168 191.04-103.008 258.336l215.2 215.168a32 32 0 0 1 0 45.248l-3.008 3.04a32 32 0 0 1-45.28 0l-218.24-218.304a373.76 373.76 0 0 1-221.12 71.968c-207.36 0-375.488-168.096-375.488-375.456S236.384 68.256 443.744 68.256zM582.4 409.6H305.056a32 32 0 0 0-32 32v4.256a32 32 0 0 0 32 32H582.4a32 32 0 0 0 32-32V441.6a32 32 0 0 0-32-32z\" fill=\"#717378\" p-id=\"7291\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ImgLes.svg
// module id = LmXa
// module chunks = 54